import CreditCardSecureColor from './CreditCardSecureColour.svg';
import CreditCardSecureDark from './CreditCardSecureDark.svg';
import CreditCardSecureLight from './CreditCardSecureLight.svg';
export const creditCardSecure = {
    color: CreditCardSecureColor,
    dark: CreditCardSecureDark,
    light: CreditCardSecureLight
};
//# sourceMappingURL=index.js.map